module.exports = __webpack_public_path__ + "media/applications/assets/images/size-info/long_sleeve_dress-db49b4fc60ff571811202b615b7bc7d4.png";